import { Container, type ContainerProps } from '@chakra-ui/react';

export type UiContainerProps = ContainerProps;

export const UiContainer = Container;
